import { theHook } from './the-hook'
import { charactersThatBreathe } from './characters-that-breathe'
import type { Chapter } from '@/types/storytelling'

/** All chapters in order. Only chapters with full content are included. */
export const chapters: Chapter[] = [theHook, charactersThatBreathe]

/** Chapter metadata for the course map (includes future locked chapters) */
export const chapterMap: { id: string; title: string; hook: string; payoff: string }[] = [
  { id: 'the-hook', title: 'The Hook', hook: 'Why do some stories pull you in instantly?', payoff: 'Learn how stories grab attention from the very first line' },
  { id: 'characters-that-breathe', title: 'Characters That Breathe', hook: 'What makes you care about someone who isn\'t real?', payoff: 'Understand why characters feel real' },
  { id: 'trouble-makes-the-story', title: 'Trouble Makes the Story', hook: 'Every great story has a problem worth solving', payoff: 'Learn why conflict pulls people forward' },
  { id: 'building-tension', title: 'Building Tension', hook: 'How do you make someone need to know what happens next?', payoff: 'Discover how to stretch suspense' },
  { id: 'worlds-that-feel-real', title: 'Worlds That Feel Real', hook: 'Setting isn\'t just where — it\'s how everything feels', payoff: 'Make places come alive on the page' },
  { id: 'the-twist', title: 'The Twist', hook: 'What happens when the story breaks its own promise?', payoff: 'Learn the art of surprise' },
  { id: 'the-moment-that-matters', title: 'The Moment That Matters', hook: 'Every story has one scene that changes everything', payoff: 'Find the heartbeat of any story' },
  { id: 'endings-that-stay', title: 'Endings That Stay', hook: 'How do you leave the reader thinking?', payoff: 'Craft endings that linger' },
]

/** Get a chapter by ID (returns undefined if not yet built) */
export function getChapter(id: string): Chapter | undefined {
  return chapters.find((c) => c.id === id)
}
